import React from 'react'
import { Link } from 'react-router-dom'

function Footer() {
  return (
    <div className='container-fluid footer'>
        <div className='row d-flex justify-content-center align-items-center'>
            <div className='col-md-4'>
                <img src={window.location.origin+'/images/logo.png'} alt="logo" className="img-fluid" style={{height:'60px',filter:"grayscale(1) brightness(10.5)"}} />
                <p className='pt-2'>
                We are an Organization, serving online-auction amenities to our clients (Public & private motor-insurance companies) with an eminence and trustworthy consumer base. Been in the domain for half a decade, we have mastered the skill offline and now have arrived into the online space with an aim to showcase supreme and delightful facilities by leveraging technological and digital resources.
                </p>
            </div>

            <div className='col-md-3'>
                <h4 style={{textTransform:"uppercase",fontSize:"20px"}}>Important Links</h4>
                <ul style={{listStyleType:"disc"}}>
                    <li><Link to="/About">About Us</Link></li>
                    
                    <li><Link to="/TermsOfUse">Terms Of Use</Link></li>
                    <li><Link to="/ContactUs">Contact Us</Link></li>
                    <li><Link to="/DeleteAccount">Delete Account</Link></li>
                </ul>
                   
            </div>
            
            <div className='col-md-2'>
                <h4 style={{textTransform:"uppercase",fontSize:"20px"}}>Download App</h4>
                <ul>
                    <li><Link to="#" target='_blank'><img src={window.location.origin + '/images/applestore.png'} alt="apple store" style={{maxHeight:"50px"}} /></Link></li>
                    <li><Link to="#" target='_blank'><img src={window.location.origin + '/images/googlestore.png'} alt="google play store" style={{maxHeight:"50px"}} /></Link></li>
                    
                </ul>
            </div>
        </div>

        <div className='row'>
            <div className='col-md-12 text-center'>
                <hr style={{borderColor:"#fff"}}/>
                <p style={{fontSize:"25px"}}>copyright &copy; Indus Spare Bazaar PVT LTD</p>
            </div>
        </div>
    </div>
  )
}

export default Footer